










import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'deleteDialog'
})
export default class extends Vue {
  @Prop() private dialog!: {
    isDeleVisible:boolean
  }
  // 功能函数

  // 表单提交
  private handleSubmit() {
    this.$emit('delete')
  }
  // ui

  // 表单取消
  private handleClose() {
    this.$emit('handleClose')
  }
}
